module.exports = __webpack_public_path__ + "static/Montaz_wspornika_lawy_stopnia_typ_C-97f37ec593742083ea89fb436d5c2360.pdf";